import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  calculateLOS,
  currentDateSingle,
  DateFormatMoment,
  formatIndianCurrency,
} from "../../../../utils/utils";
import { showErrorToast } from "../../../../assets/toastUtils";
import moment from "moment";
import PageMetaData from "../../../PageMetaData/PageMetaData";
import NewUiHeader from "../../NewUIHeader/NewUIHeader";
import FullWidthLoader from "../../../Loader/FullWidthLoader";
import ReviewReservationBanner from "../../../ReviewReservationBanner/ReviewReservationBanner";
import AddressAutocomplete from "../../../CustomGooglePlaceAPi/AddressAutocomplete";
import OurQuery from "../../../OurQuery/OurQuery";
import NewFooterUI from "../../NewFooterUI/NewFooterUI";
import Flatpickr from "react-flatpickr";
import styles from "./SingleActivity.module.scss";
import imgNotFound from "../../../../assets/images/single-image.png";
import CheckoutFooter from "../../NewFooterUI/CheckoutFooter";
import PayLater from "../../../PayLater/PayLater";

function CheckoutActivities() {
  const location = useLocation();
  const {
    activityData,
    activityPrice,
    bookingData = {},
    selectedAddOns,
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    markupData,
    activityPriceWithMarkup,
  } = location?.state || {};
  const [activityBookingData, setActivityBookingData] = useState(null);
  const item = location.state?.item;
  const [commission, setCommission] = useState({});
  const navigate = useNavigate();
  const userToken = localStorage.getItem("token");

  const [singleRoomData, setSingleRoomData] = useState(item);
  const [checkoutData, setCheckoutData] = useState({});
  const [promotions, setPromotions] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState([]);
  const [selectedAutomaticDiscount, setSelectedAutomaticDiscount] = useState(
    []
  );

  const [validity, setValidity] = useState(
    bookingData?.bookingDate || currentDateSingle
  );

  const [loader, setLoader] = useState(false);
  const [atomAccessToken, setAtomAccessToken] = useState(null);
  const [paymentGatewayLoader, setPaymentGatewayLoader] = useState(false);
  const [showPriceBreakup, setShowPriceBreakup] = useState(true);
  const [showOffers, setShowOffers] = useState(false);

  const userType = localStorage.getItem("userType");
  const userDetails = JSON?.parse(localStorage?.getItem("userDetails"));

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`; // 24-hour format
  };

  const formatTo12Hour = (time24) => {
    const [hours, minutes] = time24.split(":").map(Number);
    const ampm = hours >= 12 ? "PM" : "AM";
    const hours12 = String(hours % 12 || 12).padStart(2, "0"); // Add leading zero for single-digit hours
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${ampm}`;
  };

  const [time, setTime] = useState(getCurrentTime());
  const [guideRequired, setGuideRequired] = useState("No");

  const handleTimeChange = (event) => {
    setTime(event.target.value); // Store the raw 24-hour format time
  };

  function getAdvancePercentage(currentDate, selectedDate) {
    function getMinusDays(currentDate, selectedDate) {
      if (!currentDate || !selectedDate) return null;

      const current = new Date(currentDate);

      const selected = new Date(selectedDate);

      if (isNaN(current.getTime()) || isNaN(selected.getTime())) return null;

      current.setHours(0, 0, 0, 0);

      selected.setHours(0, 0, 0, 0);

      const diffTime = selected - current;

      return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    }

    const days = getMinusDays(currentDate, selectedDate);

    if (days === null || days < 0) return null; // Invalid or past date

    if (days >= 45 || (days >= 30 && days <= 44)) {
      return 25;
    } else if (days >= 15 && days <= 29) {
      return 50;
    }
    //  else if (days >= 7 && days <= 14) {
    //   return 75;
    // } 
    else if (days < 7) {
      return null;
    }

    return null; // fallback
  }

  const [payNow, setPayNow] = useState(null);
  const [payLater, setPayLater] = useState(null);

  const [selectedPercent, setSelectedPercent] = useState(null);

  const handlePaymentSelection = ({ selectedPercent, payNow, payLater }) => {
    setPayNow(payNow);
    setPayLater(payLater);
    setSelectedPercent(selectedPercent);
    //  console.log({ selectedPercent, payNow, payLater }, "selectedPercent");
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      checkinDay: params.get("checkinDay"),
      checkinMonth: params.get("checkinMonth"),
      checkinYear: params.get("checkinYear"),
      // checkoutDay: params.get("checkoutDay"),
      // checkoutMonth: params.get("checkoutMonth"),
      // checkoutYear: params.get("checkoutYear"),
      radio: params.get("radio"),
      childAge: childAges, // Assign the array of child ages
    };

    setCheckoutData(data);
  }, [location.search]);

  const [isPopupVisibleId, setIsPopupVisibleId] = useState(null);
  const [showPolicies, setShowPolicies] = useState(false);
  const [modifyDate, setmodifyDate] = useState(false);
  const openPopup = (id) => {
    setIsPopupVisibleId(id);
  };
  const closePopup = (id) => {
    setIsPopupVisibleId(id);
  };
  const openmodifyDate = (id) => {
    setmodifyDate(id);
  };

  const closemodifyDate = (id) => {
    setmodifyDate(id);
  };

  const [bookingValues, setBookingValues] = useState({
    activityPrice: 0,
    taxSlab: 0,
    subtotal: 0,
    taxAmount: 0,
    grandTotal: 0,
    discountAmt: 0,
    totalChildAdultCost: 0,
  });

  useEffect(() => {
    const roomRate = activityPrice * Number(bookingData?.adult);

    const bookingDiscount = selectedDiscount?.promotionAmount;
    const bookingDiscountType = selectedDiscount?.promotionMode;

    const commissionAmount = commission?.commissionAmount;
    const commissionType = commission?.commissionType;

    const calculateBookingValues = (
      activityPrice,
      bookingDiscount,
      bookingDiscountType,
      commissionAmount,
      commissionType,
      selectedAutomaticDiscount,
      selectedDiscount
    ) => {
      let taxSlab = 5;
      let taxAmount;
      let totalActivityCostWithoutAddons;

      let adjustedActivityPrice = activityPrice;

      const roomRate = adjustedActivityPrice * Number(bookingData?.adult);

      // let subtotal = roomRate + totalAddonsCost;
      let subtotal = roomRate;

      const agentSubTotal = subtotal;

      let grandTotal = 0;
      let discountAmt = 0;

      // if (bookingDiscountType === "percentage") {
      //   discountAmt = subtotal * (bookingDiscount / 100);
      // } else if (bookingDiscountType === "fixed") {
      //   discountAmt = bookingDiscount;
      // }

      const calculateAutomaticDiscountedAmount = (roomRateParsed) => {
        let finalRoomRate = roomRateParsed;
        let totalDiscount = 0;

        selectedAutomaticDiscount &&
          selectedAutomaticDiscount?.length > 0 &&
          selectedAutomaticDiscount?.forEach((discount) => {
            const { promotionMode, promotionAmount } = discount;

            if (promotionMode === "percentage") {
              const percentageDiscount =
                (finalRoomRate * parseFloat(promotionAmount)) / 100;
              totalDiscount += percentageDiscount;
              finalRoomRate -= percentageDiscount;
            } else {
              const fixedDiscount = parseFloat(promotionAmount);
              if (!isNaN(fixedDiscount)) {
                totalDiscount += fixedDiscount;
                finalRoomRate -= fixedDiscount;
              }
            }
          });

        return totalDiscount;
      };

      const calculateDiscountedAmount = (roomRateParsed) => {
        let finalRoomRate = roomRateParsed;
        let totalDiscount = 0;

        selectedDiscount &&
          selectedDiscount?.length > 0 &&
          selectedDiscount?.forEach((discount) => {
            const { promotionMode, promotionAmount } = discount;

            if (promotionMode === "percentage") {
              const percentageDiscount =
                (finalRoomRate * parseFloat(promotionAmount)) / 100;
              totalDiscount += percentageDiscount;
              finalRoomRate -= percentageDiscount;
            } else {
              const fixedDiscount = parseFloat(promotionAmount);
              if (!isNaN(fixedDiscount)) {
                totalDiscount += fixedDiscount;
                finalRoomRate -= fixedDiscount;
              }
            }
          });

        return totalDiscount;
      };

      const totalBookingAutomaticDiscountAmount =
        calculateAutomaticDiscountedAmount(subtotal);
      const totalBookingDiscountAmount = calculateDiscountedAmount(
        Number(subtotal) -
          Number(
            totalBookingAutomaticDiscountAmount
              ? totalBookingAutomaticDiscountAmount
              : 0
          )
      );

      discountAmt =
        Number(totalBookingAutomaticDiscountAmount) +
        Number(totalBookingDiscountAmount);

      subtotal -= discountAmt;

      let calculatedCommissionAmount;

      if (commissionAmount && commissionType) {
        if (commission.commissionType === "percentage") {
          calculatedCommissionAmount =
            (subtotal * commission.commissionAmount) / 100;
        } else if (commission.commissionType === "fixed") {
          calculatedCommissionAmount = commission.commissionAmount;
        }
      }

      if (calculatedCommissionAmount) {
        subtotal = subtotal - calculatedCommissionAmount;
      } else {
        subtotal = subtotal;
      }

      totalActivityCostWithoutAddons = subtotal;

      if (totalAddonsCost && totalAddonsCost > 0) {
        subtotal += totalAddonsCost;
      }

      // Calculate tax and grand total
      taxAmount = (subtotal * taxSlab) / 100;
      grandTotal = subtotal + taxAmount;

      setBookingValues({
        roomRate,
        taxSlab,
        subtotal,
        taxAmount,
        grandTotal,
        discountAmt,
        agentSubTotal,
        calculatedCommissionAmount,
        totalActivityCostWithoutAddons,
        // commissionSubTotal
        // totalChildAdultCost,
      });
    };

    if (activityPrice) {
      calculateBookingValues(
        activityPrice,
        bookingDiscount,
        bookingDiscountType,
        commissionAmount,
        commissionType,
        selectedAutomaticDiscount,
        selectedDiscount
      );
    }
  }, [
    activityPrice,
    selectedAddOns,
    selectedDiscount,
    bookingData,
    commission?.commissionAmount,
    commission?.commissionType,
    selectedAutomaticDiscount,
    selectedDiscount,
  ]);

  const [travelerDetails, settravelerDetails] = useState(true);
  // const [openPopup, setOpenPopup] = useState(false);

  const toggletravelerDetails = () => {
    settravelerDetails(!travelerDetails);
  };

  useEffect(() => {
    const updateHideToggle = () => {
      // if (window.innerWidth <= 768) {
      //   settravelerDetails(false);
      // } else {
      //   settravelerDetails(true);
      // }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  // const handleDiscountChange = (item) => {
  //   if (selectedDiscount?.id === item?.id) {
  //     setSelectedDiscount(null);
  //   } else {
  //     setSelectedDiscount(item);
  //   }
  // };

  const handleDiscountChange = (item) => {
    setSelectedDiscount([item]);
  };

  const [guestData, setGuestData] = useState({
    guest_name: "",
    guest_email: "",
    guest_phone: "",
    zipcode: "",
    activity_notes_information: "",
    guest_address: "",
    guest_country: "",
    guest_city: "",
    guest_state: "",
    gst_number: "",
    company_number: "",
    business_email: "",
  });

  const guestDataHandleChange = (event) => {
    const { name, value } = event.target;
    setGuestData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const handleAddressData = (data) => {
    setAddressData(data);
  };

  const [paymentGateways, setPaymentGateways] = useState([]);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState(null);

  const fetchPaymentGateway = async () => {
    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        key: process.env.REACT_APP_BASE_API_KEY,
      };
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/fetch/active`,
        {
          method: "GET",
          headers: headers,
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setPaymentGateways(result.data);
      const firstActiveGateway = result.data.find(
        (gateway) => gateway.gatewayName === "NTTData"
      );
      if (firstActiveGateway) {
        setSelectedPaymentGateway(firstActiveGateway);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePaymentGatewayChange = (item) => {
    setSelectedPaymentGateway(item);
  };

  const fetchPromotions = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/promotions`,
        requestOptions
      );
      const result = await response.json();
      setPromotions(result?.data);

      const applicableAutomaticPromotion = result?.data
        ?.filter((item) => {
          const isAutomatic = item.promotionType === "automatic";

          const isValidDate = checkDates(item.startDate, item.endDate);

          const isBookingWithinDiscount = checkBookingDates(
            validity,
            validity,
            item.startDate,
            item.endDate
          );

          const isUserEligible = isPromotionApplicable(
            userType === "customer"
              ? "customers"
              : userType === "agent"
              ? "agents"
              : "",
            userDetails?.id,
            item.promotionApplicable
          );

          const blackoutDates = item.promotionBlackOutDate || [];
          const isBlackout = isBlackoutDate(blackoutDates, validity);

          const isApplicableForEntity = isPromotionApplicableForEntity(
            item.promotionEntity,
            "activity",
            activityData?.activityId
          );

          const isConditionsValid = evaluateConditions(
            item.promotionConditions,
            validity
          );

          return (
            isAutomatic &&
            isValidDate &&
            isBookingWithinDiscount &&
            isUserEligible &&
            !isBlackout &&
            isApplicableForEntity &&
            isConditionsValid
          );
        })
        ?.sort((a, b) => b.stackable - a.stackable);

      let selectedPromotions = [];

      if (applicableAutomaticPromotion.length > 0) {
        const firstPromotion = applicableAutomaticPromotion[0];
        selectedPromotions.push(firstPromotion);

        if (applicableAutomaticPromotion.length > 1) {
          const secondPromotion = applicableAutomaticPromotion[1];
          if (firstPromotion.stackable && secondPromotion.stackable) {
            selectedPromotions.push(secondPromotion);
          }
        }
      }

      setSelectedAutomaticDiscount(selectedPromotions);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  };

  useEffect(() => {
    fetchPaymentGateway();
    fetchPromotions();
  }, []);

  const processPayment = async (bookingData) => {
    try {
      setPaymentGatewayLoader(true);
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        key: process.env.REACT_APP_BASE_API_KEY,
        Cookie: process.env.REACT_APP_COOKIE,
      };

      const body = JSON.stringify({
        order_amount: payNow ? Number(payNow) : bookingData?.grandTotal,
        order_number: bookingData?.bookingNo,
        order_id: bookingData?.id,
        email: bookingData?.customerDetails?.email,
        phone: bookingData?.customerDetails?.phone,
        callbackUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${bookingData?.id}`,
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/process/${selectedPaymentGateway?.gatewayName}/payment`,
        {
          method: "POST",
          headers: headers,
          body: body,
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setAtomAccessToken(result?.data);
      setPaymentGatewayLoader(false);
    } catch (error) {
      console.error("Error processing payment:", error);
      setPaymentGatewayLoader(false);
    }
  };

  useEffect(() => {
    if (selectedPaymentGateway) {
      const scriptUrl = selectedPaymentGateway?.testMode
        ? "https://pgtest.atomtech.in/staticdata/ots/js/atomcheckout.js"
        : "https://psa.atomtech.in/staticdata/ots/js/atomcheckout.js";

      const existingScript = document.querySelector(
        `script[src="${scriptUrl}"]`
      );

      if (!existingScript) {
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        script.onload = () => console.log("Atom Payment Gateway script loaded");
        script.onerror = () => console.error("Failed to load Atom script");
        document.body.appendChild(script);

        // Clean up script on unmount
        return () => {
          document.body.removeChild(script);
        };
      } else if (existingScript.readyState === "complete") {
        console.log("Atom Payment Gateway script already loaded");
      }
    }
  }, [selectedPaymentGateway]);

  useEffect(() => {
    if (
      atomAccessToken &&
      activityBookingData &&
      typeof window.AtomPaynetz !== "undefined"
    ) {
      const options = {
        merchId: process.env.REACT_APP_ATOM_MERCHANT_ID,
        atomTokenId: atomAccessToken,
        custEmail: activityBookingData?.customerDetails?.email,
        custMobile: activityBookingData?.customerDetails?.phone,
        returnUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${activityBookingData?.id}`,
      };

      const atom = new window.AtomPaynetz(options, "uat");

      const handlePaymentClick = (e) => {
        e.preventDefault();

        try {
          atom.invoke((status) => {
            if (status === "success") {
              navigate("/thank-you", {
                state: { bookingId: activityBookingData?.id },
              });
            } else if (status === "failure" || status === "cancel") {
              showErrorToast.error("Payment failed. Please try again.");
              navigate("/cancel", {
                state: { bookingId: activityBookingData?.id },
              });
            } else {
              showErrorToast("Unknown payment status. Please contact support.");
            }
          });
        } catch (err) {
          console.error("Error initiating payment", err);
          showErrorToast("Failed to initiate payment. Please try again.");
        }
      };

      const paymentButton = document.querySelector("#paymentButton");
      if (paymentButton) {
        paymentButton.addEventListener("click", handlePaymentClick);
      }

      // Clean up event listener on unmount
      return () => {
        if (paymentButton) {
          paymentButton.removeEventListener("click", handlePaymentClick);
        }
      };
    } else {
      console.warn("AtomPaynetz is not ready or required data is missing");
    }
  }, [atomAccessToken, activityBookingData, selectedPaymentGateway, navigate]);

  const handleMessage = async ({ data }) => {
    if (data === "cancelTransaction") {
      try {
        const headers = {
          Accept: "application/json",
          "Content-Type": "application/json",
          key: process.env.REACT_APP_BASE_API_KEY,
          Cookie: process.env.REACT_APP_COOKIE,
        };
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${activityBookingData?.id}`,
          {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              encData: "",
              order_id: activityBookingData?.id,
              status: "cancelled",
            }),
          }
        );
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const result = await response.json();
        navigate(
          `/thank-you?paymentGateway=${selectedPaymentGateway}&bookingId=${mainData[0]?.activityBookingData?.id}&status=cancelled`
          // `/cancel/${activityBookingData?.id}?paymentGateway=${selectedPaymentGateway?.gatewayName}&bookingId=${activityBookingData?.id}&status=cancelled`
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [activityBookingData]);

  const createBooking = async () => {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      key: process.env.REACT_APP_BASE_API_KEY,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const automaticDiscountToSend = (selectedAutomaticDiscount || []).map(
      (item) => ({
        rate: item?.promotionMode || "",
        amount: item?.promotionAmount || 0,
      })
    );

    const selectedDiscountToSend = (selectedDiscount || []).map((item) => ({
      rate: item?.promotionMode || "",
      amount: item?.promotionAmount || 0,
    }));

    const body = JSON.stringify({
      booking_type: "activity",
      customer_type: userType === "agent" ? "agent" : "customer",
      customer_name: guestData?.guest_name,
      customer_email: guestData?.guest_email,
      customer_phone: guestData?.guest_phone,
      customer_address: addressData?.address,
      customer_country: addressData?.country,
      customer_state: addressData?.state,
      customer_city: addressData?.city,
      customer_zipcode: guestData?.zipcode,
      total: bookingValues?.subtotal,
      grand_total: bookingValues?.grandTotal,
      status: "hold",
      activity_notes_information: guestData?.activity_notes_information,
      // guide_required_information: guideRequired,
      misc_details: [],
      markup_details: [
        {
          type: markupData?.markupType,
          rate: 0,
          amount: markupData?.amount,
        },
      ],
      tax_details: [
        {
          rate: bookingValues?.taxSlab,
          amount: bookingValues?.taxAmount,
        },
      ],
      activities: [
        {
          activity_id: activityData?.activityId,
          supplier_id: activityData?.supplierId,
          name: activityData?.activityName,
          destination: activityData?.activityDestination,
          validity: moment(validity).format("YYYY-MM-DD"),
          time: formatTo12Hour(time),
          pax: bookingData?.adult,
          price: activityPrice,
          adhoc: false,
        },
      ],
      addons: selectedAddOns?.map((addon) => ({
        account_addon_id: addon.addonId,
        name: addon.detail,
        price: addon.finalAddonPrice ? addon.finalAddonPrice : addon.price,
      })),
      discount_details_information: [
        ...(automaticDiscountToSend || []),
        ...(selectedDiscountToSend || []),
      ],
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/booking/create`,
        {
          method: "POST",
          headers: headers,
          body: body,
          redirect: "follow",
        }
      );

      const result = await response.json();
      if (result.success) {
        setActivityBookingData(result.data);
        processPayment(result.data);
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const mainData = [
    {
      selectedPaymentGateway: selectedPaymentGateway?.gatewayName,
      order_amount: payNow ? Number(payNow) : bookingData?.grandTotal,

      order_number: bookingData?.bookingNo,
      order_id: bookingData?.id,
      email: bookingData?.customerDetails?.email,
      phone: bookingData?.customerDetails?.phone,
      callbackUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response`,
      custEmail: activityBookingData?.customerDetails?.email,
      custMobile: activityBookingData?.customerDetails?.phone,
      returnUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response`,
    },
  ];

  // const checkDates = (startDate, endDate) => {
  //   const currentDate = new Date();
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);

  //   return currentDate >= start && currentDate <= end;
  // };

  // const checkBookingDates = (
  //   checkinBookingDate,
  //   checkoutBookingDate,
  //   discountStartDate,
  //   discountEndDate
  // ) => {
  //   const checkin = new Date(checkinBookingDate);
  //   const checkout = new Date(checkoutBookingDate);
  //   const discountStart = new Date(discountStartDate);
  //   const discountEnd = new Date(discountEndDate);

  //   return checkin <= discountEnd && checkout >= discountStart;
  // };

  const checkDates = (startDate, endDate) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = startDate.split("T")[0];
    const end = endDate.split("T")[0];
    return (
      getCurrentDateFormatted() >= start && getCurrentDateFormatted() <= end
    );
  };

  const checkBookingDates = (
    checkinBookingDate,
    checkoutBookingDate,
    discountStartDate,
    discountEndDate
  ) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const checkin = checkinBookingDate?.split("T")[0];
    const checkout = checkoutBookingDate?.split("T")[0];
    const discountStart = discountStartDate?.split("T")[0];
    const discountEnd = discountEndDate?.split("T")[0];

    return checkin <= discountEnd && checkout >= discountStart;

    // return (
    //   getCurrentDateFormatted() >= discountStart &&
    //   getCurrentDateFormatted() <= discountEnd &&
    //   checkout >= discountStart &&
    //   checkin <= discountEnd
    // );
  };

  const isPromotionApplicable = (userType, userId, promotionApplicable) => {
    if (
      Array.isArray(promotionApplicable) &&
      promotionApplicable.length === 0
    ) {
      return true;
    }

    if (promotionApplicable) {
      return promotionApplicable?.some((applicable) => {
        return (
          applicable?.applicableTo === userType &&
          applicable?.applicableIds?.includes(userId?.toString())
        );
      });
    }
  };

  const isBlackoutDate = (blackoutDates, checkDate) => {
    const normalizedCheckDate = new Date(checkDate).toLocaleDateString("en-CA");
    return blackoutDates.some((blackout) => {
      const blackoutDate = new Date(blackout.date).toISOString().split("T")[0];
      return blackoutDate === normalizedCheckDate;
    });
  };

  const isPromotionApplicableForEntity = (
    promotionEntities,
    currentEntityType,
    currentEntityId
  ) => {
    return promotionEntities.some((entity) => {
      return (
        entity.entityType === currentEntityType &&
        entity.entityIds.some(
          (id) => id.toString() === currentEntityId?.toString()
        )
      );
    });
  };

  const evaluateConditions = (conditions, validity) => {
    if (conditions.length === 0) {
      return true;
    }
    const evaluateCondition = (condition, dateToCheck) => {
      const { conditionType, conditionCondition, conditionValue } = condition;
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() + 1);
      let inputDate = new Date(dateToCheck);
      let currentDate = new Date();
      let comparisonValue;
      let valueToCompare;

      const los = calculateLOS(startDate, endDate);

      if (conditionType === "booking_date") {
        comparisonValue = moment(currentDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(currentDate);
        valueToCompare = new Date(conditionValue);
      } else if (conditionType === "LOS") {
        comparisonValue = los;
        valueToCompare = conditionValue;
      } else {
        comparisonValue = moment(inputDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(inputDate);
        valueToCompare = new Date(conditionValue);
      }

      switch (conditionCondition) {
        case "=":
          return comparisonValue.getTime() === valueToCompare.getTime();
        case ">":
          return comparisonValue > valueToCompare;
        case "!=":
          return comparisonValue != valueToCompare;
        case ">=":
          return comparisonValue >= valueToCompare;
        case "<":
          return comparisonValue < valueToCompare;
        case "<=":
          return comparisonValue <= valueToCompare;
        default:
          return false;
      }
    };
    if (conditions.length === 1) {
      return evaluateCondition(conditions[0], validity);
    }

    const logicalCondition = conditions[0].logicalCondition || "AND";

    let result = logicalCondition === "AND" ? true : false;

    for (const condition of conditions) {
      const conditionResult = evaluateCondition(condition, validity);

      if (logicalCondition === "OR") {
        result = result || conditionResult;
      } else {
        result = result && conditionResult;
      }
    }

    return result;
  };

  // commission api
  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/activity/${activityData?.activityId}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (
          data?.data?.commissionType != "none" &&
          data?.data?.commissionAmount !== 0
        ) {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userType === "agent") {
      fetchCommissions();
    }
  }, [userType]);

  return (
    <div className={styles.checkout_activities}>
      {paymentGatewayLoader && <FullWidthLoader />}
      <PageMetaData
        title="Mountain Mysteries"
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      />
      <NewUiHeader />
      <section className={styles.section_with_background}>
        <div className="container">
          <div
            className={styles.main_flex}
            style={{ margin: "0", padding: "0" }}
          >
            <div className={styles.reservation_content}>
              <div className={styles.list_details}>
                <div className="flex justify_content_between align_items_center cursor_pointer ">
                  <h4 className="text-left">Traveller Details</h4>
                </div>

                <form action="">
                  <div className={styles.form_data}>
                    <div>
                      <div>
                        <label htmlFor="">Full Name</label>
                        <input
                          className="HotelCheckout-Input"
                          id="guest_name"
                          type="text"
                          name="guest_name"
                          value={guestData.guest_name}
                          onChange={guestDataHandleChange}
                          required
                          placeholder="Enter full name"
                        />
                      </div>
                    </div>
                    <div className="input-flex mt-10">
                      <div className="CheckoutHotel-Fields">
                        <div className="flex align_items_center flex_gap_5">
                          {" "}
                          <label htmlFor="">Email Address </label>
                          <svg
                            width="12"
                            height="13"
                            viewBox="0 0 12 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.66667 9.5H6.33333V5.83333H5.66667V9.5ZM6 4.88467C6.11622 4.88467 6.21367 4.84533 6.29233 4.76667C6.371 4.688 6.41033 4.59056 6.41033 4.47433C6.41033 4.35811 6.371 4.26067 6.29233 4.182C6.21367 4.10344 6.11622 4.06417 6 4.06417C5.88378 4.06417 5.78633 4.10344 5.70767 4.182C5.629 4.26067 5.58967 4.35811 5.58967 4.47433C5.58967 4.59056 5.629 4.688 5.70767 4.76667C5.78633 4.84533 5.88378 4.88467 6 4.88467ZM6.00217 12.5C5.1725 12.5 4.39244 12.3426 3.662 12.0277C2.93167 11.7128 2.29633 11.2854 1.756 10.7457C1.21567 10.2059 0.787944 9.57111 0.472833 8.84133C0.157611 8.11167 0 7.33194 0 6.50217C0 5.6725 0.157444 4.89244 0.472333 4.162C0.787222 3.43167 1.21456 2.79633 1.75433 2.256C2.29411 1.71567 2.92889 1.28794 3.65867 0.972833C4.38833 0.657611 5.16806 0.5 5.99783 0.5C6.8275 0.5 7.60756 0.657445 8.338 0.972334C9.06833 1.28722 9.70367 1.71456 10.244 2.25433C10.7843 2.79411 11.2121 3.42889 11.5272 4.15867C11.8424 4.88833 12 5.66806 12 6.49783C12 7.3275 11.8426 8.10756 11.5277 8.838C11.2128 9.56833 10.7854 10.2037 10.2457 10.744C9.70589 11.2843 9.07111 11.7121 8.34133 12.0272C7.61167 12.3424 6.83194 12.5 6.00217 12.5ZM6 11.8333C7.48889 11.8333 8.75 11.3167 9.78333 10.2833C10.8167 9.25 11.3333 7.98889 11.3333 6.5C11.3333 5.01111 10.8167 3.75 9.78333 2.71667C8.75 1.68333 7.48889 1.16667 6 1.16667C4.51111 1.16667 3.25 1.68333 2.21667 2.71667C1.18333 3.75 0.666667 5.01111 0.666667 6.5C0.666667 7.98889 1.18333 9.25 2.21667 10.2833C3.25 11.3167 4.51111 11.8333 6 11.8333Z"
                              fill="#1C1B1F"
                            />
                          </svg>
                        </div>

                        <input
                          className="HotelCheckout-Input"
                          id="guest_email"
                          name="guest_email"
                          value={guestData.guest_email}
                          onChange={guestDataHandleChange}
                          required
                          placeholder="Enter email address"
                        />
                      </div>

                      <div className="CheckoutHotel-Fields">
                        <div className="flex align_items_center flex_gap_5">
                          <label htmlFor="">Phone</label>{" "}
                          <svg
                            width="12"
                            height="13"
                            viewBox="0 0 12 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.66667 9.5H6.33333V5.83333H5.66667V9.5ZM6 4.88467C6.11622 4.88467 6.21367 4.84533 6.29233 4.76667C6.371 4.688 6.41033 4.59056 6.41033 4.47433C6.41033 4.35811 6.371 4.26067 6.29233 4.182C6.21367 4.10344 6.11622 4.06417 6 4.06417C5.88378 4.06417 5.78633 4.10344 5.70767 4.182C5.629 4.26067 5.58967 4.35811 5.58967 4.47433C5.58967 4.59056 5.629 4.688 5.70767 4.76667C5.78633 4.84533 5.88378 4.88467 6 4.88467ZM6.00217 12.5C5.1725 12.5 4.39244 12.3426 3.662 12.0277C2.93167 11.7128 2.29633 11.2854 1.756 10.7457C1.21567 10.2059 0.787944 9.57111 0.472833 8.84133C0.157611 8.11167 0 7.33194 0 6.50217C0 5.6725 0.157444 4.89244 0.472333 4.162C0.787222 3.43167 1.21456 2.79633 1.75433 2.256C2.29411 1.71567 2.92889 1.28794 3.65867 0.972833C4.38833 0.657611 5.16806 0.5 5.99783 0.5C6.8275 0.5 7.60756 0.657445 8.338 0.972334C9.06833 1.28722 9.70367 1.71456 10.244 2.25433C10.7843 2.79411 11.2121 3.42889 11.5272 4.15867C11.8424 4.88833 12 5.66806 12 6.49783C12 7.3275 11.8426 8.10756 11.5277 8.838C11.2128 9.56833 10.7854 10.2037 10.2457 10.744C9.70589 11.2843 9.07111 11.7121 8.34133 12.0272C7.61167 12.3424 6.83194 12.5 6.00217 12.5ZM6 11.8333C7.48889 11.8333 8.75 11.3167 9.78333 10.2833C10.8167 9.25 11.3333 7.98889 11.3333 6.5C11.3333 5.01111 10.8167 3.75 9.78333 2.71667C8.75 1.68333 7.48889 1.16667 6 1.16667C4.51111 1.16667 3.25 1.68333 2.21667 2.71667C1.18333 3.75 0.666667 5.01111 0.666667 6.5C0.666667 7.98889 1.18333 9.25 2.21667 10.2833C3.25 11.3167 4.51111 11.8333 6 11.8333Z"
                              fill="#1C1B1F"
                            />
                          </svg>
                        </div>
                        <input
                          className="HotelCheckout-Input"
                          type="number"
                          id="guest_phone"
                          name="guest_phone"
                          value={guestData.guest_phone}
                          onChange={guestDataHandleChange}
                          required
                          placeholder="Enter phone number"
                        />
                      </div>
                      <div className="CheckoutHotel-Fields w-half">
                        <label htmlFor="">Zipcode</label>
                        <input
                          className="HotelCheckout-Input"
                          type="number"
                          id="zipcode"
                          name="zipcode"
                          value={guestData.zipcode}
                          onChange={guestDataHandleChange}
                          placeholder="Zipcode"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className={styles.list_details}>
                <div className="flex justify_content_between  align_items_center cursor_pointer">
                  <h4 className="text-left">Traveller Address</h4>
                </div>

                <form action="">
                  <div className={styles.form_data}>
                    <div className="mt-10">
                      <label htmlFor="address">Address</label>
                      <AddressAutocomplete
                        formdata={addressData}
                        onAddressChange={handleAddressData}
                      />
                    </div>

                    <div className="mt-10">
                      <label htmlFor="address">Additional Details</label>
                      <textarea
                        className="HotelCheckout-Input mt-10"
                        id="activity_notes_information"
                        name="activity_notes_information"
                        value={guestData.activity_notes_information}
                        onChange={guestDataHandleChange}
                        required
                        placeholder="Additional Details"
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className={styles.list_details}>
                <div
                  className="flex justify_content_between align_items_center cursor_pointer"
                  onClick={toggletravelerDetails}
                >
                  <h4>Booking Details</h4>
                  <svg
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transition: "transform 0.4s",
                      transform: travelerDetails
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <path
                      d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                      stroke="#222222"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>

                {travelerDetails && (
                  <div>
                    {" "}
                    <div className={styles.booking_data}>
                      <div className={styles.booking_data_flex}>
                        {" "}
                        {activityData?.activityImages?.length > 0 ? (
                          <img
                            src={activityData.activityImages[0]}
                            alt="hotel-image"
                          />
                        ) : (
                          <img src={imgNotFound} alt="Image not found" />
                        )}
                        <div>
                          {" "}
                          <h5>{activityData?.activityName}</h5>
                          <small className="flex mt-10 align_items_center">
                            {" "}
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_5983_7301"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="20"
                                height="20"
                              >
                                <rect width="20" height="20" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_5983_7301)">
                                <path
                                  d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                  fill="#888888"
                                />
                              </g>
                            </svg>
                            {activityData.activityDestination}
                          </small>
                        </div>
                      </div>
                      <div className={styles.time_slot}>
                        <div>
                          <small>Travel Date</small>
                          <span> {DateFormatMoment(validity)} </span>
                        </div>
                        <div>
                          {" "}
                          <small>Time slot</small>
                          <span> {time}</span>
                        </div>
                        <div>
                          {" "}
                          <small>Adults</small>
                          <span> {bookingData?.adult} Adults</span>
                        </div>
                      </div>
                      <div className={styles.booking_details}>
                        <div></div>
                        <div className={styles.policies}>
                          <div>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_5985_9337"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="16"
                                height="16"
                              >
                                <rect width="16" height="16" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_5985_9337)">
                                <path
                                  d="M6.36641 12.0003L2.56641 8.20031L3.51641 7.25031L6.36641 10.1003L12.4831 3.98364L13.4331 4.93364L6.36641 12.0003Z"
                                  fill="#009A50"
                                />
                              </g>
                            </svg>
                            Free Cancellation before 7 days
                          </div>
                          {activityData?.activityLegals &&
                            activityData?.activityLegals.length > 0 && (
                              <div>
                                {activityData?.activityLegals
                                  ?.filter(
                                    (item) =>
                                      item?.type === "cancellation_policy"
                                  ) // Filter only cancellation policies
                                  .map((item) => (
                                    <div key={item?.policyId}>
                                      <button
                                        onClick={() => setShowPolicies(item)}
                                        className={styles.know_more}
                                      >
                                        Know More
                                      </button>
                                    </div>
                                  ))}
                              </div>
                            )}
                        </div>
                      </div>

                      {showPolicies && (
                        <div className="bg-backdrop">
                          <div className="bg-white activity-legals">
                            <div className="flex justify_content_between align_items_center">
                              <h5>{showPolicies?.name}</h5>
                              <svg
                                onClick={() => setShowPolicies(null)}
                                width="14"
                                height="13"
                                viewBox="0 0 14 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 12.5L13 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                                <path
                                  d="M13 12.5L1 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                              </svg>
                            </div>
                            <div className="policy_content mt-10">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: showPolicies?.content,
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* booking details of checkout hotel page */}
              {/* <div className={styles.list_details}>
                <div
                  className="flex justify_content_between p_10 align_items_center cursor_pointer"
                  onClick={toggletravelerDetails}
                >
                  <h4>Booking Details hotels</h4>
                  <svg
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transition: "transform 0.4s",
                      transform: travelerDetails
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <path
                      d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                      stroke="#222222"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>

                {travelerDetails && (
                  <div style={{ padding: "0 10px 10px 10px" }}>
                    {" "}
                    <div className={styles.booking_data_hotels}>
                      <div className={styles.booking_data_flex}>
                        {" "}
                        {activityData?.activityImages?.length > 0 ? (
                          <img
                            src={activityData.activityImages[0]}
                            alt="hotel-image"
                          />
                        ) : (
                          <img src={imgNotFound} alt="Image not found" />
                        )}
                        <div className={styles.content_sec}>
                          {" "}
                          <div className={styles.rating}>
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 0.5L8.5716 5.33688H13.6574L9.5429 8.32624L11.1145 13.1631L7 10.1738L2.8855 13.1631L4.4571 8.32624L0.342604 5.33688H5.4284L7 0.5Z"
                                fill="#ECB119"
                              />
                            </svg>
                            {item?.hotel_rating
                              ? Number(item?.hotel_rating)
                              : 0}{" "}
                            Star
                          </div>
                          <h5>{activityData?.activityName}</h5>
                          <small className="flex  align_items_center">
                            {" "}
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_5983_7301"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="20"
                                height="20"
                              >
                                <rect width="20" height="20" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_5983_7301)">
                                <path
                                  d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                  fill="#888888"
                                />
                              </g>
                            </svg>
                            {activityData.activityDestination}
                          </small>
                        </div>
                      </div>
                      <div className={styles.time_slot}>
                        <div>
                          <small>check in</small>
                          <span> {DateFormatMoment(validity)} </span>
                        </div>
                        <div>
                          {" "}
                          <small>check out</small>
                          <span> {time}</span>
                        </div>
                        <div>
                          {" "}
                          <small>aDULTS & ROOMS</small>
                          <span> {bookingData?.adult} Adults</span>
                        </div>
                      </div>
                      <div className={styles.booking_details}>
                        <div>
                          <span>Room & Meal Plan</span>
                          <ul>
                            <li>1 x Super Deluxe Room</li>
                            <li>Room Only</li>
                          </ul>
                        </div>
                        <div className={styles.policies}>
                          <div>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_5985_9337"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="16"
                                height="16"
                              >
                                <rect width="16" height="16" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_5985_9337)">
                                <path
                                  d="M6.36641 12.0003L2.56641 8.20031L3.51641 7.25031L6.36641 10.1003L12.4831 3.98364L13.4331 4.93364L6.36641 12.0003Z"
                                  fill="#009A50"
                                />
                              </g>
                            </svg>
                            Free Cancellation before 7 days
                          </div>
                          <button className={styles.know_more}>
                            Know More
                          </button>
                        </div>
                      </div>
                      {showPolicies && (
                        <div className="bg-backdrop">
                          <div className="bg-white activity-legals">
                            <div className="flex justify_content_between align_items_center">
                              <h5>{showPolicies?.name}</h5>
                              <svg
                                onClick={() => setShowPolicies(null)}
                                width="14"
                                height="13"
                                viewBox="0 0 14 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 12.5L13 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                                <path
                                  d="M13 12.5L1 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                              </svg>
                            </div>
                            <div className="policy_content mt-10">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: showPolicies?.content,
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div> */}
              {/* booking details of checkout packages page */}
              {/* <div className={styles.list_details}>
                <div
                  className="flex justify_content_between p_10 align_items_center cursor_pointer"
                  onClick={toggletravelerDetails}
                >
                  <h4>Booking Details Packages</h4>
                  <svg
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      transition: "transform 0.4s",
                      transform: travelerDetails
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    <path
                      d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                      stroke="#222222"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>

                {travelerDetails && (
                  <div style={{ padding: "0 10px 10px 10px" }}>
                    {" "}
                    <div className={styles.booking_data_packages}>
                      <div className={styles.booking_data_flex}>
                        {" "}
                        {activityData?.activityImages?.length > 0 ? (
                          <img
                            src={activityData.activityImages[0]}
                            alt="hotel-image"
                          />
                        ) : (
                          <img src={imgNotFound} alt="Image not found" />
                        )}
                        <div className={styles.content_sec}>
                          {" "}
                          <div className={styles.location}>
                            <div>
                              <svg
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_5990_6365"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="14"
                                  height="15"
                                >
                                  <rect
                                    y="0.5"
                                    width="14"
                                    height="14"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_5990_6365)">
                                  <path
                                    d="M9.02596 10.1407L9.64079 9.52584L7.43754 7.32259V4.58325H6.56254V7.67711L9.02596 10.1407ZM7.00106 13.0416C6.23456 13.0416 5.5141 12.8961 4.83967 12.6053C4.16523 12.3144 3.5786 11.9196 3.07975 11.4209C2.5809 10.9223 2.18594 10.3359 1.89485 9.66175C1.60387 8.98761 1.45837 8.26734 1.45837 7.50094C1.45837 6.73444 1.60382 6.01397 1.89471 5.33954C2.1856 4.66511 2.58037 4.07847 3.07902 3.57963C3.57767 3.08078 4.16407 2.68581 4.83821 2.39473C5.51235 2.10374 6.23262 1.95825 6.99902 1.95825C7.76552 1.95825 8.48599 2.1037 9.16042 2.39459C9.83485 2.68547 10.4215 3.08025 10.9203 3.5789C11.4192 4.07755 11.8141 4.66395 12.1052 5.33809C12.3962 6.01222 12.5417 6.73249 12.5417 7.4989C12.5417 8.2654 12.3963 8.98586 12.1054 9.66029C11.8145 10.3347 11.4197 10.9214 10.9211 11.4202C10.4224 11.9191 9.83601 12.314 9.16187 12.6051C8.48774 12.8961 7.76746 13.0416 7.00106 13.0416ZM7.00004 12.1666C8.2931 12.1666 9.39414 11.7121 10.3032 10.803C11.2122 9.89402 11.6667 8.79297 11.6667 7.49992C11.6667 6.20686 11.2122 5.10582 10.3032 4.19679C9.39414 3.28777 8.2931 2.83325 7.00004 2.83325C5.70698 2.83325 4.60594 3.28777 3.69692 4.19679C2.78789 5.10582 2.33337 6.20686 2.33337 7.49992C2.33337 8.79297 2.78789 9.89402 3.69692 10.803C4.60594 11.7121 5.70698 12.1666 7.00004 12.1666Z"
                                    fill="#1C1B1F"
                                  />
                                </g>
                              </svg>
                              6d/5n
                            </div>
                            <div>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_5983_7301"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="18"
                                >
                                  <rect width="18" height="18" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_5983_7301)">
                                  <path
                                    d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                    fill="#1C1B1F"
                                  />
                                </g>
                              </svg>
                              ex chandigarh
                            </div>
                          </div>
                          <h5>{activityData?.activityName}</h5>
                        </div>
                      </div>
                      <div className={styles.time_slot}>
                        <div>
                          <small>Tour Date</small>
                          <span> {DateFormatMoment(validity)} </span>
                        </div>
                        <div>
                          {" "}
                          <small>Adults & children</small>
                          <span> {bookingData?.adult} Adults</span>
                        </div>
                        <div>
                          {" "}
                          <small>Paclkage category</small>
                          <span> {time}</span>
                        </div>
                      </div>
                      <div className={styles.booking_details}>
                        <div></div>
                        <div className={styles.policies}>
                          <button className={styles.know_more}>
                            Review Itinerary
                          </button>
                        </div>
                      </div>
                      {showPolicies && (
                        <div className="bg-backdrop">
                          <div className="bg-white activity-legals">
                            <div className="flex justify_content_between align_items_center">
                              <h5>{showPolicies?.name}</h5>
                              <svg
                                onClick={() => setShowPolicies(null)}
                                width="14"
                                height="13"
                                viewBox="0 0 14 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 12.5L13 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                                <path
                                  d="M13 12.5L1 0.5"
                                  stroke="#AAAAAA"
                                  strokeWidth="1.2"
                                />
                              </svg>
                            </div>
                            <div className="policy_content mt-10">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: showPolicies?.content,
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div> */}

              <div>
                {paymentGateways.length > 0 ? (
                  <>
                    <div className={styles.buttons}>
                      <h4>Payment gateway</h4>
                      {paymentGateways &&
                        paymentGateways.map((item, index) => (
                          <>
                            <div
                              key={index}
                              className="flex discountSingleDiv justify_content_between w-100"
                            >
                              <div className="flex">
                                <label
                                  style={{
                                    textTransform: "capitalize",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                  htmlFor={item?.gatewayName}
                                >
                                  <input
                                    checked={
                                      selectedPaymentGateway?.gatewayName ===
                                      item?.gatewayName
                                    }
                                    onChange={() =>
                                      handlePaymentGatewayChange(item)
                                    }
                                    type="radio"
                                    id={item?.gatewayName}
                                  />
                                  <div style={{ cursor: "pointer" }}>
                                    <div>{item.gatewayName}</div>
                                  </div>
                                </label>
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                    {currentDateSingle != validity && (
                      <PayLater
                        totalAmt={bookingValues.grandTotal}
                        fiftyPercentAmount={getAdvancePercentage(
                          currentDateSingle,
                          validity
                        )}
                        onSelectionChange={handlePaymentSelection}
                      />
                    )}
                    <div className={styles.buttons}>
                      <button
                        style={{ marginTop: "10px" }}
                        className={styles.book_btn}
                        onClick={createBooking}
                      >
                        Proceed to Payment
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_6067_16102"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="17"
                            height="17"
                          >
                            <rect
                              x="0.5"
                              y="0.5"
                              width="16"
                              height="16"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6067_16102)">
                            <path
                              d="M11.2837 9.16674H3.83366C3.64477 9.16674 3.48644 9.10285 3.35866 8.97507C3.23088 8.8473 3.16699 8.68896 3.16699 8.50007C3.16699 8.31118 3.23088 8.15285 3.35866 8.02507C3.48644 7.89729 3.64477 7.83341 3.83366 7.83341H11.2837L8.01699 4.56674C7.88366 4.43341 7.81977 4.27785 7.82533 4.10007C7.83088 3.9223 7.90033 3.76674 8.03366 3.63341C8.16699 3.51118 8.32255 3.4473 8.50033 3.44174C8.6781 3.43618 8.83366 3.50007 8.96699 3.63341L13.367 8.03341C13.4337 8.10007 13.4809 8.1723 13.5087 8.25007C13.5364 8.32785 13.5503 8.41118 13.5503 8.50007C13.5503 8.58896 13.5364 8.6723 13.5087 8.75007C13.4809 8.82785 13.4337 8.90007 13.367 8.96674L8.96699 13.3667C8.84477 13.489 8.69199 13.5501 8.50866 13.5501C8.32533 13.5501 8.16699 13.489 8.03366 13.3667C7.90033 13.2334 7.83366 13.0751 7.83366 12.8917C7.83366 12.7084 7.90033 12.5501 8.03366 12.4167L11.2837 9.16674Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>
                  </>
                ) : (
                  <div className={styles.buttons}>
                    <button
                      style={{ marginTop: "10px" }}
                      // onClick={bookPackageHandle}
                      disabled={true}
                      className={styles.book_btn}
                    >
                      Proceed to Payment
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_6067_16102"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="17"
                          height="17"
                        >
                          <rect
                            x="0.5"
                            y="0.5"
                            width="16"
                            height="16"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6067_16102)">
                          <path
                            d="M11.2837 9.16674H3.83366C3.64477 9.16674 3.48644 9.10285 3.35866 8.97507C3.23088 8.8473 3.16699 8.68896 3.16699 8.50007C3.16699 8.31118 3.23088 8.15285 3.35866 8.02507C3.48644 7.89729 3.64477 7.83341 3.83366 7.83341H11.2837L8.01699 4.56674C7.88366 4.43341 7.81977 4.27785 7.82533 4.10007C7.83088 3.9223 7.90033 3.76674 8.03366 3.63341C8.16699 3.51118 8.32255 3.4473 8.50033 3.44174C8.6781 3.43618 8.83366 3.50007 8.96699 3.63341L13.367 8.03341C13.4337 8.10007 13.4809 8.1723 13.5087 8.25007C13.5364 8.32785 13.5503 8.41118 13.5503 8.50007C13.5503 8.58896 13.5364 8.6723 13.5087 8.75007C13.4809 8.82785 13.4337 8.90007 13.367 8.96674L8.96699 13.3667C8.84477 13.489 8.69199 13.5501 8.50866 13.5501C8.32533 13.5501 8.16699 13.489 8.03366 13.3667C7.90033 13.2334 7.83366 13.0751 7.83366 12.8917C7.83366 12.7084 7.90033 12.5501 8.03366 12.4167L11.2837 9.16674Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </div>

            <aside>
              <div className={styles.price_breakup}>
                <>
                  {promotions.length > 0 && (
                    <>
                      {promotions.some((item) => {
                        const isCouponCode =
                          item?.promotionType === "coupon" ? true : false;

                        const isValidDate = checkDates(
                          item.startDate,
                          item.endDate
                        );

                        const isBookingWithinDiscount = checkBookingDates(
                          validity,
                          validity,
                          item.startDate,
                          item.endDate
                        );

                        const isUserEligible = isPromotionApplicable(
                          userType === "customer"
                            ? "customers"
                            : userType === "agent"
                            ? "agents"
                            : "",
                          userDetails?.id,
                          item.promotionApplicable
                        );

                        const blackoutDates = item.promotionBlackOutDate || [];

                        const isBlackout = isBlackoutDate(
                          blackoutDates,
                          validity
                        );

                        const isApplicableForEntity =
                          isPromotionApplicableForEntity(
                            item.promotionEntity,
                            "activity",
                            activityData?.activityId
                          );

                        const isConditionsValid = evaluateConditions(
                          item.promotionConditions,
                          validity
                        );

                        return (
                          isCouponCode &&
                          isValidDate &&
                          isBookingWithinDiscount &&
                          isUserEligible &&
                          !isBlackout &&
                          isApplicableForEntity &&
                          isConditionsValid
                        );
                      }) && (
                        <div
                          className="discount_new_ui"
                          style={{
                            background: showOffers ? "#FFFCF3" : "#FFFFFF",
                          }}
                        >
                          <div className="flex justify_content_between cursor_pointer">
                            <div
                              className="flex justify_content_between w-100 mb-10"
                              onClick={() => setShowOffers(!showOffers)}
                            >
                              <div>
                                <h5 className="text-left">Offers</h5>
                              </div>
                              <button>
                                <svg
                                  width="13"
                                  height="8"
                                  viewBox="0 0 13 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{
                                    transition: "transform 0.3s",
                                    transform: showOffers
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                  }}
                                >
                                  <path
                                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                    stroke="#222222"
                                    strokeWidth="1.5"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>

                          {showOffers && (
                            <div>
                              {promotions.map((item, index) => {
                                const isCouponCode =
                                  item?.promotionType === "coupon"
                                    ? true
                                    : false;

                                const isValidDate = checkDates(
                                  item.startDate,
                                  item.endDate
                                );

                                const isBookingWithinDiscount =
                                  checkBookingDates(
                                    validity,
                                    validity,
                                    item.startDate,
                                    item.endDate
                                  );

                                const isUserEligible = isPromotionApplicable(
                                  userType === "customer"
                                    ? "customers"
                                    : userType === "agent"
                                    ? "agents"
                                    : "",
                                  userDetails?.id,
                                  item.promotionApplicable
                                );

                                const blackoutDates =
                                  item.promotionBlackOutDate || [];

                                const isBlackout = isBlackoutDate(
                                  blackoutDates,
                                  validity
                                );

                                const isApplicableForEntity =
                                  isPromotionApplicableForEntity(
                                    item.promotionEntity,
                                    "activity",
                                    activityData?.activityId
                                  );

                                const isConditionsValid = evaluateConditions(
                                  item.promotionConditions,
                                  validity
                                );

                                return (
                                  isCouponCode &&
                                  isValidDate &&
                                  isBookingWithinDiscount &&
                                  isUserEligible &&
                                  !isBlackout &&
                                  isApplicableForEntity &&
                                  isConditionsValid && (
                                    <div
                                      key={index}
                                      className="flex mt-10 p_10 justify_content_between w-100"
                                      style={{
                                        backgroundColor: selectedDiscount?.some(
                                          (discount) => discount.id === item.id
                                        )
                                          ? "#E8F9F1"
                                          : "transparent",
                                        border: selectedDiscount?.some(
                                          (discount) => discount.id === item.id
                                        )
                                          ? "0.5px solid #E8F9F1"
                                          : "0.5px solid #ccc",
                                      }}
                                    >
                                      <div>
                                        <label
                                          style={{
                                            textTransform: "capitalize",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textTransform: "uppercase",
                                            cursor: "pointer",
                                          }}
                                          htmlFor={item?.promotionName}
                                        >
                                          {" "}
                                          <input
                                            // checked={
                                            //   selectedDiscount?.id === item?.id
                                            // }
                                            // onChange={() =>
                                            //   handleDiscountChange(item)
                                            // }
                                            // type="radio"
                                            // id={item?.promotionName}

                                            checked={selectedDiscount?.some(
                                              (discount) =>
                                                discount.id === item.id
                                            )}
                                            onChange={() =>
                                              handleDiscountChange(item)
                                            }
                                            type="radio"
                                            id={item.promotionName}
                                          />
                                          <div>
                                            <div>
                                              {item?.promotionName?.replace(
                                                /-/g,
                                                " "
                                              )}
                                            </div>
                                          </div>
                                        </label>
                                      </div>
                                      <div>
                                        {item?.promotionMode === "fixed" ? (
                                          formatIndianCurrency(
                                            item?.promotionAmount
                                          )
                                        ) : (
                                          <>{item?.promotionAmount}%</>
                                        )}
                                      </div>
                                    </div>
                                  )
                                );
                              })}
                              <div className="flex justify_content_end w-100 mt-10">
                                {selectedDiscount && (
                                  <button
                                    className="view_btn"
                                    onClick={() => setSelectedDiscount([])}
                                  >
                                    clear
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </>
                <div
                  className={styles.common_bg}
                  style={{
                    background: showPriceBreakup ? "#FFFCF3" : "#FFFFFF",
                    padding: "15px",
                  }}
                >
                  {/* <h5 className="text-left">Price Breakup</h5> */}

                  <div
                    className="flex justify_content_between pointer"
                    onClick={() => setShowPriceBreakup(!showPriceBreakup)}
                  >
                    <h4 style={{ fontSize: "16px" }}>Price Breakup</h4>
                    <button>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        style={{
                          transition: "transform 0.3s",
                          transform: showPriceBreakup
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <mask
                          id="mask0_6802_2345"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect
                            y="18.5"
                            width="18"
                            height="18"
                            transform="rotate(-90 0 18.5)"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6802_2345)">
                          <path
                            d="M8.99971 11.6113L14.6493 5.9617C14.7983 5.8127 14.9737 5.74008 15.1756 5.74383C15.3776 5.7477 15.5531 5.82414 15.7021 5.97314C15.8511 6.12227 15.9256 6.29777 15.9256 6.49964C15.9256 6.70152 15.8511 6.87702 15.7021 7.02614L9.96027 12.7794C9.82464 12.915 9.67271 13.0155 9.50446 13.0809C9.33621 13.1463 9.16796 13.179 8.99971 13.179C8.83146 13.179 8.66321 13.1463 8.49496 13.0809C8.32671 13.0155 8.17477 12.915 8.03914 12.7794L2.28571 7.02614C2.13671 6.87702 2.06414 6.69958 2.06802 6.49383C2.07189 6.28808 2.14833 6.1107 2.29733 5.9617C2.44633 5.8127 2.62183 5.7382 2.82383 5.7382C3.02571 5.7382 3.20114 5.8127 3.35014 5.9617L8.99971 11.6113Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                    </button>
                  </div>

                  {showPriceBreakup && (
                    <div
                      className="mt-10"
                      style={{ borderTop: "0.5px solid #ccc" }}
                    >
                      <div className="flex justify_content_between mt-10">
                        <div>Activity Price</div>

                        <span
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                          }}
                        >
                          {formatIndianCurrency(activityPrice)}
                        </span>
                      </div>

                      <div className="flex justify_content_between mt-10">
                        <div>
                          Total Cost{" "}
                          <small> {bookingData?.adult} Traveler</small>
                        </div>
                        <span>
                          {formatIndianCurrency(
                            Number(bookingValues?.roomRate)
                          )}
                        </span>
                      </div>

                      {(selectedAutomaticDiscount.length > 0 ||
                        selectedDiscount.length > 0) && (
                        <div>
                          <div
                            style={{
                              margin: "10px 0",
                              borderTop: "1px solid #ccc",
                              paddingTop: "10px",
                            }}
                          >
                            <b>
                              Activity Discount
                              {selectedAutomaticDiscount?.length > 1 ? "s" : ""}
                            </b>
                          </div>
                          {selectedAutomaticDiscount?.map((discount, index) => (
                            <div
                              className="flex justify_content_between mt-2"
                              key={discount.id}
                            >
                              <span className="discount-name">
                                {discount.promotionName}
                              </span>
                              <span>
                                {discount.promotionMode === "percentage"
                                  ? `${+discount.promotionAmount}%`
                                  : `${formatIndianCurrency(
                                      discount.promotionAmount
                                    )}`}
                              </span>
                            </div>
                          ))}

                          {selectedDiscount &&
                            selectedDiscount?.length > 0 &&
                            selectedDiscount?.map((discount, index) => (
                              <div
                                className="flex justify_content_between mt-2"
                                key={discount.id}
                              >
                                <span className="discount-name">
                                  {discount.promotionName}
                                </span>
                                <span>
                                  {discount.promotionMode === "percentage"
                                    ? `${+discount.promotionAmount}%`
                                    : `${formatIndianCurrency(
                                        discount.promotionAmount
                                      )}`}
                                </span>
                              </div>
                            ))}
                        </div>
                      )}

                      {bookingValues?.discountAmt > 0 && (
                        <div className="flex justify_content_between mt-10">
                          <div>Discount Amt.</div>
                          <span>
                            {formatIndianCurrency(bookingValues?.discountAmt)}
                          </span>
                        </div>
                      )}

                      {commission && Object.keys(commission).length > 0 && (
                        <>
                          <div className="flex justify_content_between mt-10">
                            <div>
                              Commission
                              <small>
                                ({" "}
                                {commission.commissionType === "fixed" ? (
                                  <span>
                                    {formatIndianCurrency(
                                      commission?.commissionAmount
                                    )}
                                  </span>
                                ) : (
                                  <setPaymentGateways>
                                    {commission?.commissionAmount}%
                                  </setPaymentGateways>
                                )}
                                )
                              </small>
                            </div>
                            <span>
                              {formatIndianCurrency(
                                bookingValues?.calculatedCommissionAmount
                              )}
                            </span>
                          </div>
                        </>
                      )}

                      {bookingValues?.totalActivityCostWithoutAddons > 0 &&
                        totalAddonsCost > 0 && (
                          <div className="flex justify_content_between mt-10">
                            <div>Total Activity Cost</div>
                            <span>
                              {formatIndianCurrency(
                                bookingValues?.totalActivityCostWithoutAddons
                              )}
                            </span>
                          </div>
                        )}

                      {selectedAddOns && selectedAddOns.length > 0 && (
                        <div className="flex justify_content_between mt-10">
                          <div>Addons Price</div>

                          <span
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "end",
                            }}
                          >
                            {commission &&
                              Object.keys(commission).length > 0 &&
                              totalAddonsCostWithoutCommission && (
                                <small
                                  style={{
                                    color: "red",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {formatIndianCurrency(
                                    totalAddonsCostWithoutCommission
                                  )}
                                </small>
                              )}
                            <b>{formatIndianCurrency(totalAddonsCost)}</b>
                          </span>
                          {/* <span className="room_text-right">
      {formatIndianCurrency(totalAddonsCost)}
    </span> */}
                        </div>
                      )}

                      {/* {selectedAddOns && selectedAddOns.length > 0 && ( */}
                      <div
                        className="flex justify_content_between mt-10"
                        style={{
                          borderTop: "1px solid #ccc",
                          paddingTop: "10px",
                        }}
                      >
                        <div>Sub total</div>
                        <span>
                          {formatIndianCurrency(
                            Number(bookingValues?.subtotal)
                          )}
                        </span>
                      </div>
                      {/* )} */}

                      <div className="flex justify_content_between mt-10">
                        <div>
                          Tax Slab <small>({bookingValues?.taxSlab}%)</small>
                        </div>
                        <span>
                          {formatIndianCurrency(bookingValues.taxAmount)}
                        </span>
                      </div>
                      <div
                        className="flex justify_content_between mt-10"
                        style={{
                          borderTop: "1px solid #ccc",
                          paddingTop: "10px",
                        }}
                      >
                        <h6>Grand Total</h6>
                        <h6>
                          {formatIndianCurrency(bookingValues.grandTotal)}
                        </h6>
                      </div>

                      {payNow !== null &&
                        !isNaN(payNow) &&
                        payNow !== 0 &&
                        selectedPercent !== 100 && (
                          <div
                            className="flex justify_content_between mt-10"
                            style={{
                              borderTop: "1px solid #cccccc7c",
                              paddingTop: "10px",
                            }}
                          >
                            <h6>Total Amount to be paid</h6>
                            <h6>{formatIndianCurrency(payNow)}</h6>
                          </div>
                        )}
                    </div>
                  )}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
      <CheckoutFooter />

      <div className={styles.mobile_price_breakup}>
        <div className="">
          <div>Total Amt.</div>
          <h6>
            <b>
              {" "}
              {formatIndianCurrency(
                payNow ? Number(payNow) : bookingValues.grandTotal
              )}
            </b>
          </h6>
        </div>
        <button className={styles.book_btn} onClick={createBooking}>
          Proceed to Payment
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_6067_16102"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="17"
              height="17"
            >
              <rect x="0.5" y="0.5" width="16" height="16" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6067_16102)">
              <path
                d="M11.2837 9.16674H3.83366C3.64477 9.16674 3.48644 9.10285 3.35866 8.97507C3.23088 8.8473 3.16699 8.68896 3.16699 8.50007C3.16699 8.31118 3.23088 8.15285 3.35866 8.02507C3.48644 7.89729 3.64477 7.83341 3.83366 7.83341H11.2837L8.01699 4.56674C7.88366 4.43341 7.81977 4.27785 7.82533 4.10007C7.83088 3.9223 7.90033 3.76674 8.03366 3.63341C8.16699 3.51118 8.32255 3.4473 8.50033 3.44174C8.6781 3.43618 8.83366 3.50007 8.96699 3.63341L13.367 8.03341C13.4337 8.10007 13.4809 8.1723 13.5087 8.25007C13.5364 8.32785 13.5503 8.41118 13.5503 8.50007C13.5503 8.58896 13.5364 8.6723 13.5087 8.75007C13.4809 8.82785 13.4337 8.90007 13.367 8.96674L8.96699 13.3667C8.84477 13.489 8.69199 13.5501 8.50866 13.5501C8.32533 13.5501 8.16699 13.489 8.03366 13.3667C7.90033 13.2334 7.83366 13.0751 7.83366 12.8917C7.83366 12.7084 7.90033 12.5501 8.03366 12.4167L11.2837 9.16674Z"
                fill="white"
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
}

export default CheckoutActivities;
